import { Controller } from "@hotwired/stimulus";

// No behavior of its own — the search box's live-ish debounce lives on
// Ui::MarketNavbarComponent (the element that actually owns the form), matching
// this project's convention of every component carrying its own controller file
// even when, like this top-level page shell, it has nothing to wire up itself.
export default class extends Controller {
  connect() {}
}
